import { render } from "./manage_details.vue?vue&type=template&id=760680ff"
import script from "./manage_details.vue?vue&type=script&lang=js"
export * from "./manage_details.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__